import * as React from "react";

const TankSidebarRate =  (props) => {

    const idName = props.linkedId + "_hintbox";

    const locs = {
        TOTAL: gettext("Total"),
        SPECIAL_EARN_RATE: gettext("Special earn rate modifier"),
        PREMIUM_BONUS_EARN_RATE: gettext("Premium bonus earn rate")
    };

    return (
        <div id={idName} className="hintbox hintbox__tank" data-placement="right" data-hover="true">
            <span className="tank-stat-rate_block-wrapper">
                <span className="tank-stat-rate_block tank-stat-rate_block__base">
                    <p>{props.baseRateText}</p>
                    <span>{props.baseRate}%</span>
                </span>
                {
                    props.bonusRate > 0 && props.linkedId !== "js-free-xp-bonus"? (
                        <span className="tank-stat-rate_block tank-stat-rate_block__premium">
                            <p>{locs.PREMIUM_BONUS_EARN_RATE}</p>
                            <span>{props.bonusRate}%</span>
                        </span>
                    ) : (
                        <span className="tank-stat-rate_block">
                            <p>{locs.SPECIAL_EARN_RATE}</p>
                            <span>{props.bonusRate}%</span>
                        </span>
                    )
                }
            </span>
            <span className="tank-stat-rate_block">
                <p>{locs.TOTAL}</p>
                <span>{props.baseRate + props.bonusRate}%</span>
            </span>
        </div>
    )
};

export default TankSidebarRate;